import React, { Component } from 'react'
import Item from './item'

export class Items extends Component {
  render() {
    return (
      <div className='items'>
          {this.props.items.length &&
            this.props.items.map(elem=>(
                <Item key={elem.id} products={elem} onAdd={this.props.onAdd} onShowItem={this.props.onShowItem}/>
              ))
              || <div className='items__not-found'>Не найдено </div>
          }
      </div>
    )
  }
}

export default Items